$(document).on('submit', 'form', function (e) {
    var button = $(e.originalEvent?.submitter)
    if (!Boolean(button)) {
        return
    }
    if (button.hasClass('no-disabler')) {
        return
    }
    showLoading(button)
})

window.hideButtonLoading = hideLoading
window.showButtonLoading = showLoading

function hideLoading(button) {
    button.removeAttr('disabled')
    button.find('i.fa.fa-spin').remove()
}

function showLoading(button) {
    button.prepend('<i class="fa fa-circle-o-notch fa-spin"></i> ')
        .attr('disabled', 'disabled')
}